import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import '../stylings/NotFound.css';

export default function NotFound() {
  return (
    <Layout bannerTitle="Page Not Found">
      <section className="not-found-section">
        <div className="container text-center">
          <div className="not-found-content">
            <div className="not-found-number">404</div>
            <h2>Oops! Page Not Found</h2>
            <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
            <Link to="/" className="not-found-home-btn">
              <i className="fas fa-home me-2"></i>Back to Home
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
